"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactVirtualized = require("react-virtualized");

var _lodash = _interopRequireDefault(require("lodash"));

require("react-virtualized/styles.css");

// Libraries
// Assets
var Grid =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Grid, _React$Component);

  function Grid(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Grid);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
    _this.cache = new _reactVirtualized.CellMeasurerCache({
      defaultWidth: 100,
      fixedHeight: true
    });
    return _this;
  }

  (0, _createClass2["default"])(Grid, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          height = _this$props.height,
          headerHeight = _this$props.headerHeight,
          rowHeight = _this$props.rowHeight,
          columns = _this$props.columns,
          rows = _this$props.rows,
          children = _this$props.children;
      return _react["default"].createElement(_reactVirtualized.ScrollSync, null, function (_ref) {
        var clientHeight = _ref.clientHeight,
            clientWidth = _ref.clientWidth,
            onScroll = _ref.onScroll,
            scrollHeight = _ref.scrollHeight,
            scrollLeft = _ref.scrollLeft,
            scrollTop = _ref.scrollTop,
            scrollWidth = _ref.scrollWidth;
        return _react["default"].createElement(_reactVirtualized.AutoSizer, {
          disableHeight: true
        }, function (_ref2) {
          var width = _ref2.width;
          return _react["default"].createElement("div", null, _react["default"].createElement(_reactVirtualized.Grid, {
            columnCount: columns.length,
            columnWidth: _this2.cache.columnWidth,
            height: headerHeight || rowHeight,
            rowHeight: headerHeight || rowHeight,
            rowCount: 1,
            overscanColumnCount: 0,
            scrollLeft: scrollLeft,
            width: width,
            deferredMeasurementCache: _this2.cache,
            cellRenderer: function cellRenderer(_ref3) {
              var key = _ref3.key,
                  columnIndex = _ref3.columnIndex,
                  rowIndex = _ref3.rowIndex,
                  parent = _ref3.parent,
                  style = _ref3.style;
              return _react["default"].createElement(_reactVirtualized.CellMeasurer, {
                key: key,
                columnIndex: columnIndex,
                rowIndex: rowIndex,
                cache: _this2.cache,
                parent: parent
              }, _react["default"].createElement("div", {
                style: style
              }, children({
                header: true,
                columnIndex: columnIndex,
                item: _lodash["default"].get(columns, columnIndex)
              })));
            },
            style: {
              // NOTE(mark): Must specify these separately because of how
              // they are merged in.
              overflowX: 'hidden',
              overflowY: 'hidden'
            }
          }), _react["default"].createElement(_reactVirtualized.Grid, {
            columnCount: columns.length,
            columnWidth: _this2.cache.columnWidth,
            height: height,
            rowCount: rows.length,
            rowHeight: rowHeight,
            width: width,
            overscanColumnCount: 0,
            overscanRowCount: 2,
            deferredMeasurementCache: _this2.cache,
            onScroll: onScroll,
            cellRenderer: function cellRenderer(_ref4) {
              var key = _ref4.key,
                  columnIndex = _ref4.columnIndex,
                  rowIndex = _ref4.rowIndex,
                  parent = _ref4.parent,
                  style = _ref4.style;
              return _react["default"].createElement(_reactVirtualized.CellMeasurer, {
                key: key,
                columnIndex: columnIndex,
                rowIndex: rowIndex,
                cache: _this2.cache,
                parent: parent
              }, _react["default"].createElement("div", {
                style: style
              }, children({
                header: false,
                columnIndex: columnIndex,
                rowIndex: rowIndex,
                item: _lodash["default"].get(rows, "".concat(rowIndex, ".").concat(columnIndex))
              })));
            }
          }));
        });
      });
    }
  }]);
  return Grid;
}(_react["default"].Component);

var _default = Grid;
exports["default"] = _default;